import PropTypes from "prop-types";

import { StrategyContainer } from "./GetStartedModal.styles";
import RecommendedModalHeader from "../ModalHeader";
import { Button } from "components/Button/index";

const RecommendedStrategyModal = ({ show, onHide, handleGetStart }) => {
  return (
    <StrategyContainer heading="" show={show} onHide={onHide}>
      <RecommendedModalHeader />
      <div className="content-wrapper">
        <h3 className="heading">Recommended strategies</h3>
        <p className="description">
          We are excited to announce that Surmount has partnered with Investment
          Advisor Quantitative Finance to bring you expertly recommended
          strategies. By answering a few quick suitability questions, we’ll
          match you with strategies that align with your personal goals and
          preferences, backed by cutting-edge quantitative analysis to support
          your financial journey.
        </p>
        <div className="start-button">
          <Button size="small" onClick={handleGetStart}>
            Get Started
          </Button>
        </div>
      </div>
    </StrategyContainer>
  );
};

RecommendedStrategyModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  handleGetStart: PropTypes.func,
};

export { RecommendedStrategyModal };
